/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DataCentersEnum = 'AP' | 'EM' | 'US' | 'LT' | 'ALL';

export const DataCentersEnum = {

    AP: 'AP' as DataCentersEnum,

    EM: 'EM' as DataCentersEnum,

    US: 'US' as DataCentersEnum,

    LT: 'LT' as DataCentersEnum,

    ALL: 'ALL' as DataCentersEnum
};

